import { handleSpreadingCompactionTabActiveChange } from "./spreading-compaction/spreadingCompactionService";

type TStoreLike = {
	state: Record<string, unknown>;
	getters: Record<string, unknown>;
	commit: (type: string, payload?: unknown) => void;
};

type TTabTransitionHandler = (store: TStoreLike, activeTab: string) => void;

const tabTransitionHandlers: TTabTransitionHandler[] = [
	(store, activeTab) => {
		handleSpreadingCompactionTabActiveChange(
			store.state,
			activeTab === "tab4",
			() => store.commit("spreadingCompaction/SET_ACTIVE", false),
		);
	},
];

export function handleFeatureTabTransition(
	store: TStoreLike,
	activeTab: string,
): void {
	for (const handler of tabTransitionHandlers) {
		handler(store, activeTab);
	}
}
